import i18n, { type InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend, { type HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import translationEN from "../assets/locales/en/translations.json";
import translationES from "../assets/locales/es/translations.json";
import translationJA from "../assets/locales/ja/translations.json";
import translationPT from "../assets/locales/pt/translations.json";
import translationFR from "../assets/locales/fr/translations.json";
import { isProduction } from "./constants";

export const defaultNS = "translations";
export const resources = {
  en: { translations: translationEN },
  es: { translations: translationES },
  ja: { translations: translationJA },
  pt: { translations: translationPT },
  fr: { translations: translationFR },
} as const;

const detector = new LanguageDetector(null, {
  caches: [],
});

const i18nOptions: InitOptions = {
  // lng: "pt",
  defaultNS,
  ns: [defaultNS],
  debug: !isProduction,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  supportedLngs: ["en", "es", "ja", "pt", "fr"],
  resources: resources,
};

void i18n
  .use(initReactI18next)
  .use(detector)
  .use(Backend)
  .init<HttpBackendOptions>(i18nOptions);

export default i18n;
